import React, { useEffect, useContext } from 'react';
import { useNavigate, Link } from "react-router-dom";




export default function Companies() {


    return (
      <div>
        <div className="header pb-6">
          <div className="container-fluid">
            <div className="header-body">
              <div className="row align-items-center py-4">
                <div className="col-lg-6 col-7">
                  <h2 className="h2 d-inline-block mb-0">Companies</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
}